// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"2f8e8b46","564":"05f7058b","570":"6d62ad1f","948":"3c5ed640"}[chunkId] + ".chunk.js";
};